import Vue from 'vue'
import Vuex from 'vuex'
import getters from "./getters"
import user from './modules/user'
import app from './modules/app'
import tagsView from '@/store/index/modules/tagsView'
Vue.use(Vuex)
const fullScreen = {
    state: {
        // 全屏
        fullscreen: false,
    },
    mutations: {
        // 全屏
        SET_FULLSCREEN: (state, fullscreen) => {
            state.fullscreen = fullscreen
            console.log('执行全屏')
        },
    },

    actions: {}
}
const store = new Vuex.Store({
    modules: {
        app,
        // settings,
        user,
        fullScreen,
        tagsView
    },
    getters

    /*state: {
        // 放置初始状态 app启动的时候的全局的初始值
        isCollapse: false,
        menus: [],
        token: '',
        username: '',
        avatar: ''
    },
    mutations: {
        collapseMenu (state) {
            state.isCollapse = !state.isCollapse
        },
        addMenu (state,menus) {
            menus.forEach((item) => {
                state.menus.push(item)
            })
        },
        addUser (state,userInfo) {
            state.username = userInfo.username
            state.avatar = userInfo.avatar
        },
        addToken (state,token) {
            state.token = token
        }
    }*/
})

export default store
